import { useCallback } from 'react';

import { checkCurrentUser, useSaveDataRequest } from '@futrli/shared-services';
import { useCurrentUser } from '@futrli/views/hooks/useCurrentUser';

type RequestDataType = Awaited<ReturnType<typeof checkCurrentUser>>;

/**
 * Loads the current user data
 */
export const useSaveUserData = () => {
  const view = useCurrentUser();
  const { save: saveData, ...rest } = useSaveDataRequest<RequestDataType>();

  const save = useCallback(
    async (newData: Partial<RequestDataType>) => {
      return saveData(view.updateCurrentUser(newData as Record<string, string>));
    },
    [saveData, view]
  );

  return {
    save,
    ...rest
  };
};
